import { Logo } from "./Logo";
import { SERVICES, CONTACT_EMAIL } from "../data/content";
import { scrollToId } from "../lib/scroll";

export default function Footer() {
  return (
    <footer className="border-t border-cyan-500/10 bg-[#05080F]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="grid gap-10 md:grid-cols-[1.3fr_1fr_1fr]">
          <div>
            <Logo />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
              Independent IT support & digital solutions for individuals, freelancers and small businesses across
              Birmingham and the West Midlands — and remotely across the UK.
            </p>
            <p className="mt-4 font-mono text-xs text-cyan-400">Your goals + My skills = Real solutions.</p>
            <p className="mt-3 text-xs text-slate-500">Professional Member of BCS, The Chartered Institute for IT (MBCS).</p>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">Services</p>
            <ul className="mt-4 space-y-2">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <button
                    onClick={() => scrollToId("services")}
                    className="text-sm text-slate-400 transition-colors hover:text-cyan-300"
                    data-testid={`footer-service-${s.id}`}
                  >
                    {s.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">Contact</p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="mt-4 block text-sm text-slate-300 transition-colors hover:text-cyan-300"
              data-testid="footer-email-link"
            >
              {CONTACT_EMAIL}
            </a>
            <p className="mt-3 text-sm text-slate-400">Birmingham & West Midlands, UK</p>
            <p className="mt-1 text-sm text-slate-400">Remote support available UK-wide</p>
            <button
              onClick={() => scrollToId("enquiry")}
              className="mt-5 rounded-full border border-cyan-500/40 px-5 py-2.5 text-sm font-semibold text-cyan-300 transition-colors hover:bg-cyan-500/10"
              data-testid="footer-enquiry-button"
            >
              Start an enquiry
            </button>
          </div>
        </div>
        <div className="mt-12 flex flex-wrap items-center justify-between gap-4 border-t border-white/5 pt-6">
          <p className="text-xs text-slate-600">© 2026 WA Digital Solutions · Birmingham, United Kingdom</p>
          <div className="flex items-center gap-5">
            <a href="/privacy" className="text-xs text-slate-500 transition-colors hover:text-cyan-300" data-testid="footer-privacy-link">
              Privacy & Confidentiality
            </a>
            <a href="/terms" className="text-xs text-slate-500 transition-colors hover:text-cyan-300" data-testid="footer-terms-link">
              Terms of Service
            </a>
            <a href="/admin/login" className="text-xs text-slate-700 transition-colors hover:text-slate-400" data-testid="footer-admin-link">
              Owner login
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
